// extracted by mini-css-extract-plugin
export default {"folder":"folder__M2XCG","changeLink":"changeLink__CO12R"};